// CookieTrigger.js
//
// Persistent entry point for reopening the cookie settings after a decision
// has been made (GDPR/DSGVO Art. 7(3): withdrawing consent must be as easy as
// giving it). Rendered by templates/trigger.php only when the feature is
// enabled, so every method no-ops when the container is absent.

class CookieTrigger {
  constructor(cookieConsent) {
    this.cookieConsent = cookieConsent;
    this.init();
  }

  init() {
    this.container = document.querySelector(".mad-cc-trigger__container");
    if (!this.container) return;

    this.button = this.container.querySelector(".mad-cc-trigger");
    if (this.button) {
      this.button.addEventListener("click", () => this.onClick());
    }
  }

  onClick() {
    this.cookieConsent.modal.show();
  }

  show() {
    if (this.container) this.container.classList.add("active");
  }

  hide() {
    if (this.container) this.container.classList.remove("active");
  }

  /**
   * The trigger and the banner share the bottom corners, so the trigger only
   * appears once the banner is gone — i.e. once a decision has been recorded.
   *
   * Call this only from sites that also hide the banner (acceptAll, denyAll,
   * the modal's save handler, and init). CookieConsent.onCookieConsentGiven /
   * onCookieCategoryConsentGiven set `hide_cookie_banner` WITHOUT hiding the
   * banner — the video-consent path relies on that — so syncing from there
   * would draw the trigger on top of a still-visible banner. Those paths pick
   * the trigger up on the next page load via init() instead.
   */
  syncVisibility() {
    if (this.cookieConsent.getCookie("hide_cookie_banner") === "true") {
      this.show();
    } else {
      this.hide();
    }
  }
}

module.exports = CookieTrigger;
